import { render, staticRenderFns } from "./CustomEmptyLegsAndSpacesForm.vue?vue&type=template&id=22114404&"
import script from "./CustomEmptyLegsAndSpacesForm.vue?vue&type=script&lang=js&"
export * from "./CustomEmptyLegsAndSpacesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports